<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-ticker-queues" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'menu:TickerQueues' | i18next : { defaultValue: 'Ticker Queues' } }}</span>
    <div class="right">
      <app-filter-input id="filter-input-ticker-queues" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
      <div class="toggleButtons" style="margin-left: 24px;">
        <app-basic-button id="day-window-btn-ticker-queues" [type]="selectedWindow === 'day' ? 'primary' : 'secondary'" [text]="'ticker:day' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('day')" [dropShadow]="false"></app-basic-button>
        <app-basic-button id="week-window-btn-ticker-queues" [type]="selectedWindow === 'week' ? 'primary' : 'secondary'" [text]="'ticker:week' | i18next" fontSize="12px"
        size="small" (click)="onSelectWindow('week')" [dropShadow]="false"></app-basic-button>
      </div>
    </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- ✅ No Data Template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

      <!-- Queue -->
      <ng-container matColumnDef="queue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:queues_queue' | i18next : { defaultValue: 'Queue' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left nowrap">
          {{ r.queue }}
        </td>
      </ng-container>

      <!-- Total Offered -->
      <ng-container matColumnDef="totalOffered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:queues_totalOffered' | i18next : { defaultValue: 'Total offered' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.totalOffered }}
        </td>
      </ng-container>

      <!-- Total Answered -->
      <ng-container matColumnDef="totalAnswered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:queues_totalAnswered' | i18next : { defaultValue: 'Total answered' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.totalAnswered }}
        </td>
      </ng-container>

      <!-- Avg Survey Score (conditional) -->
      <ng-container *ngIf="showSurveyScore" matColumnDef="avgSurveyScore">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgSurveyScore' | i18next : { defaultValue: 'Avg survey score' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.formattedAvgSurveyScore }}
        </td>
      </ng-container>

      <!-- Answer Rate -->
      <ng-container matColumnDef="answerRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:queues_answerRate' | i18next : { defaultValue: 'Answer rate' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{!r.formattedAnswerRate || r.formattedAnswerRate=="NaN"?('ticker:NaN' | i18next):r.formattedAnswerRate }}
        </td>
      </ng-container>

      <!-- Answer Rate SLA -->
      <ng-container matColumnDef="answerRateWithinSla">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:queues_answerRateSLA' | i18next : { defaultValue: 'Answer rate (SLA)' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{!r.formattedAnswerRateWithinSla || r.formattedAnswerRateWithinSla=="NaN"?('ticker:NaN' | i18next):r.formattedAnswerRateWithinSla }}
        </td>
      </ng-container>

      <!-- Avg Wait -->
      <ng-container matColumnDef="secondsAvgWait">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgWaitTime' | i18next : { defaultValue: 'Avg wait' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.formattedSecondsAvgWait }}
        </td>
      </ng-container>

      <!-- Avg Speak -->
      <ng-container matColumnDef="secondsAvgSpeak">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgSpeakTime' | i18next : { defaultValue: 'Avg speak' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
              {{!r.formattedSecondsAvgSpeak || r.formattedSecondsAvgSpeak=="NaN"?('ticker:NaN' | i18next):r.formattedSecondsAvgSpeak }}
        </td>
      </ng-container>

      <!-- Avg Wrapup -->
      <ng-container matColumnDef="secondsAvgWrapup">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgWrapupTime' | i18next : { defaultValue: 'Avg wrapup' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
               {{!r.formattedSecondsAvgWrapup || r.formattedSecondsAvgWrapup=="NaN"?('ticker:NaN' | i18next):r.formattedSecondsAvgWrapup }}
        </td>
      </ng-container>

      <!-- AHT -->
      <ng-container matColumnDef="aht">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_AHT' | i18next : { defaultValue: 'AHT' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.formattedSecondsAHT }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- ✅ No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

    </table>
  </div>
</div>
